import React, { useState} from "react";
import { TMSSearchTextOvTrn} from "./tms-filters-search-ovtrn";

export const TMSFiltersOvTrn = (isBlankActiveOvtm) => {
  const [inputValue, setInputValue] = useState(isBlankActiveOvtm);
    return (
        <TMSSearchTextOvTrn isBlankActiveOvtm={isBlankActiveOvtm}/> 
  );
};
